module.exports = __webpack_public_path__ + "img/t-shirt-2.2293e8f2.png";